import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Box } from '../../design/css';
import { Text } from '../css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { getButton } from '../../srtDashboard/utils';
import OrderAssignee from './orderAssignee';

const OrderHeader = ({
  userRights,
  order,
  defaultAssignee,
  assignee,
  onAssigneeChange,
  onClickSave,
  users,
  isDisabled
}) => {
  const [assigneeModal, setAssigneeModal] = useState(false);
  const localizedString = useLocalizedStringsContext();
  const {
    ORDERS: {
      orderId,
      orderStatus,
      statusText,
      businessLegalName,
      orderAssignedTo,
      assign,
      unassigned
    }
  } = localizedString;

  return (
    <>
      <Box pb={12}>
        <Text bold color="#4B286D">
          {orderId}:{' '}
        </Text>
        <Text>{order.orderId}</Text>
      </Box>
      <Box pb={12}>
        <Text bold color="#4B286D">
          {businessLegalName}:{' '}
        </Text>
        <Text>{order.businessLegalName}</Text>
      </Box>
      <Box pb={12}>
        <Text bold color="#4B286D">
          {orderStatus}:{' '}
        </Text>
        <Text>{statusText[order.status]} </Text>
      </Box>
      <Box>
        <Text bold color="#4B286D">
          {orderAssignedTo}:{' '}
        </Text>
        <Text>
          {defaultAssignee.length > 0 ? defaultAssignee[0].label : unassigned}{' '}
        </Text>
        {userRights.canAssignOrder &&
          !isDisabled &&
          getButton(
            () => setAssigneeModal(true),
            `[ ${assign.toLowerCase()} ]`
          )}
      </Box>
      {assigneeModal && (
        <OrderAssignee
          assignee={assignee}
          users={users}
          onAssigneeChange={onAssigneeChange}
          onClickSave={onClickSave}
          setAssigneeModal={setAssigneeModal}
        />
      )}
    </>
  );
};

OrderHeader.propTypes = {
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool
  }).isRequired,
  order: PropTypes.shape({
    id: PropTypes.number,
    orderId: PropTypes.string,
    status: PropTypes.string,
    businessLegalName: PropTypes.string
  }).isRequired,
  defaultAssignee: PropTypes.arrayOf(PropTypes.string).isRequired,
  assignee: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAssigneeChange: PropTypes.func.isRequired,
  onClickSave: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number
    })
  ).isRequired
};

export default OrderHeader;
